import React from 'react';
import PropTypes from 'prop-types';
import BoxModelValue from './box-model-value';
import { POSITION } from './constants';
import noop from '../../../utils/noop';

const BoxModel = ({ padding, margin, onChange = noop }) => (
  <div className="ws-ui-box-model">
    <div className="ws-ui-box-model__margin-box">
      {margin.label && <span className="ws-ui-box-model__label">{margin.label}</span>}

      <BoxModelValue position={POSITION.top} property={margin} onChange={onChange} />
      <BoxModelValue position={POSITION.right} property={margin} onChange={onChange} />
      <BoxModelValue position={POSITION.bottom} property={margin} onChange={onChange} />
      <BoxModelValue position={POSITION.left} property={margin} onChange={onChange} />

      <div className="ws-ui-box-model__padding-box">
        {padding.label && <div className="ws-ui-box-model__label">{padding.label}</div>}

        <BoxModelValue position={POSITION.top} property={padding} onChange={onChange} />
        <BoxModelValue position={POSITION.right} property={padding} onChange={onChange} />
        <BoxModelValue position={POSITION.bottom} property={padding} onChange={onChange} />
        <BoxModelValue position={POSITION.left} property={padding} onChange={onChange} />

        <div className="ws-ui-box-model__content-box" />
      </div>
    </div>
  </div>
);

BoxModel.propTypes = {
  padding: PropTypes.shape({
    top: PropTypes.number.isRequired,
    right: PropTypes.number.isRequired,
    bottom: PropTypes.number.isRequired,
    left: PropTypes.number.isRequired,
    label: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
  }).isRequired,
  margin: PropTypes.shape({
    top: PropTypes.number.isRequired,
    right: PropTypes.number.isRequired,
    bottom: PropTypes.number.isRequired,
    left: PropTypes.number.isRequired,
    label: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
  }).isRequired,
  onChange: PropTypes.func,
};

export default BoxModel;
